import React from 'react';

import * as S from './WebsiteCard.styles';

interface WebsiteCardProps {
  title: string;
  url: string;
  favicon: string;
}

export const WebsiteCard = ({ title, url, favicon }: WebsiteCardProps) => {
  return (
    <S.CardWrapper>
      <S.Content>
        <S.Favicon src={favicon} alt={title} />
        <S.InfoWrapper>
          <S.Title>{title}</S.Title>
          <S.Url>{url}</S.Url>
        </S.InfoWrapper>
      </S.Content>
    </S.CardWrapper>
  );
};
